import { Component, output } from '@angular/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule, MatIconButton } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelect, MatSelectModule } from '@angular/material/select';

interface Quarter {
  startMonth: number;
  label: string;
  months: string;
}

@Component({
  imports: [
    MatFormFieldModule,
    MatSelectModule,
    MatButtonModule,
    MatCardModule,
    MatAutocompleteModule,
    MatInputModule,
    MatIconModule,
    MatIconButton,
  ],
  selector: 'norupe-quarterly-picker',
  styles: ``,
  templateUrl: './quarterly-picker.component.html',
})
export class QuarterlyPickerComponent {
  startDate = output<Date | null>();
  endDate = output<Date | null>();

  selectedQuarter: number | null = null;

  quarters: Quarter[] = [
    { label: 'Q1', months: 'Janv., Febr., Marts', startMonth: 0 },
    { label: 'Q2', months: 'Apr., Maijs, Jūn.', startMonth: 3 },
    { label: 'Q3', months: 'Jūl., Aug., Sept.', startMonth: 6 },
    { label: 'Q4', months: 'Okt., Nov., Dec.', startMonth: 9 },
  ];

  year = new Date().getFullYear();

  change(count: number) {
    this.year += count;

    //if there is quarter selected emit the start  and end when switching years
    if (this.selectedQuarter !== null) {
      this.onQuarterSelected(this.selectedQuarter);
    }
  }

  onQuarterSelected(startMonth: number) {
    this.selectedQuarter = startMonth;

    const start = new Date(this.year, startMonth, 1);
    const end = new Date(this.year, startMonth + 3, 0);

    this.startDate.emit(start);
    this.endDate.emit(end);
  }

  clearDate(select: MatSelect) {
    select.value = null;
    this.selectedQuarter = null;
    this.startDate.emit(null);
    this.endDate.emit(null);
  }
}
